import { Result } from '@empathy/search-types';
import { QueryOrigin } from '../query-origin.model';

export interface RecommendationsState {
  lastCount: number;
  hasMore: boolean;
  loading: boolean;
  page: number;
  infiniteScrollEnabled: boolean;
  recommendations: Result[];
  origin: QueryOrigin | string;
}

export enum RecommendationsParentModuleKey {
  emptySearch = 'emptySearch',
  noResults = 'noResults'
}
